import * as types from '../const/action.types';

export function setWarningReaded(value) {
    return {
        type: types.SET_WARNING_READED,
        value,
    };
}



// WEBPACK FOOTER //
// ./src/actions/alert.warning.actions.js